var t = /:not\(:focus-visible\)/g,
    a = /:focus-visible/g,
    n = function n(t) {
  return t.trim().replace(/\s+/g, " ");
};

export default function (i, e, u, r, o, c, f) {
  return 2 === i && u.forEach(function (i, e) {
    if (i.match(t)) {
      var r = i.replace(t, ":focus");
      u[e] = n('\n          [data-whatinput]:not([data-whatinput="keyboard"]) ' + r + ',\n          [data-whatinput]:not([data-whatinput="initial"]) ' + r + "\n        ");
    } else if (i.match(a)) {
      var o = i.replace(a, ":focus");
      u[e] = n('\n          [data-whatinput="keyboard"] ' + o + ',\n          [data-whatinput="initial"] ' + o + "\n        ");
    }
  }), e;
}